import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { unAuthGuard } from './core/guards/un-auth.guard';
import { authGuard } from './core/guards/auth.guard';
import { FileSaverComponent } from './shared/components/file-saver/file-saver.component';
import { SchoolManagerMeetingComponent } from './shared/components/school-manager-meeting/school-manager-meeting.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { UserTypeComponent } from './authentication/user-type/user-type.component';
import { ConfigService } from './core/config/config.service';
import { getDashboardRoutes } from './core/routes/dashboard.route';
import { userTypeGuard } from './authentication/user-type/user-type.guard';

export function getRoutes(configService: ConfigService): Routes {
  return [
    {
      path: 'auth',
      loadChildren: () =>
        import('./authentication/authentication.module').then(
          (m) => m.AuthenticationModule
        ),
      canActivate: [unAuthGuard]
    },
    {
      path: 'file-view/:id',
      component: FileSaverComponent
    },
    {
      path: 'school-manager-meeting',
      component: SchoolManagerMeetingComponent
    },
    {
      path: 'user-type',
      loadComponent: () =>
        import('./authentication/auth-layout/auth-layout.component').then(
          (m) => m.AuthLayoutComponent
        ),
      children: [
        {
          path: '',
          component: UserTypeComponent,
          data: { title: 'user-type.title' }
        }
      ],
      canActivate: [authGuard, userTypeGuard]
    },
    {
      path: '',
      loadComponent: () =>
        import('./layout/layout.component').then((m) => m.LayoutComponent),
      children: [
        ...getDashboardRoutes(configService),
        { path: 'page-not-found', component: PageNotFoundComponent },
        { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' }
      ],
      data: { breadcrumb: 'breadcrumb.workspace' },
      canActivate: [authGuard, userTypeGuard],
      canActivateChild: [userTypeGuard]
    }
  ];
}

@NgModule({
  imports: [
    RouterModule.forRoot([], {
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(router: Router, configService: ConfigService) {
    router.resetConfig(getRoutes(configService));
  }
}
